<template>
	<v-card elevation="3">
		<v-form>
			<v-card-title primary-title>
				{{ !vacationType ? $T('title') : $T('title-permission') }}
				<v-spacer></v-spacer>
				<v-btn
					@click="$emit('close')"
					icon>
					<v-icon color="alert-color">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row dense>
					<!-- employee -->
					<v-col cols="12">
						<v-autocomplete
							:disabled="!!oneEmployee || !employees.length"
							v-model="employee"
							:items="employees"
							:loading="!employees.length"
							return-object
							item-value="employeeId"
							:label="$T('employee')"
							:filter="
								(item, queryText) =>
									item.code?.includes(queryText) || item.arabicFullName.includes(queryText)
							"
							dense
							outlined
							hide-details>
							<template v-slot:item="{ item }">
								<div
									class="d-flex justify-space-between text-caption"
									style="width: 100%">
									<div>
										({{ item.code }})
										{{ item.arabicFullName }}
									</div>
									<div>
										{{ item.sectionName }}
									</div>
								</div>
							</template>
							<template v-slot:selection="{ item }">
								<div
									class="d-flex justify-space-between"
									style="min-width: 100%">
									<div>
										({{ item.code }})
										{{ item.arabicFullName }}
									</div>
									<div>
										{{ item.sectionName }}
									</div>
								</div>
							</template>
						</v-autocomplete>
					</v-col>
					<!-- timeType -->
					<v-col cols="12">
						<v-radio-group
							v-model="addVacation.timeType"
							dense
							row
							hide-details
							mandatory
							class="mt-1">
							<v-radio
								:label="$T('addVacation.forDay')"
								:value="0"></v-radio>
							<v-radio
								:label="$T('addVacation.forHour')"
								:value="1"></v-radio>
						</v-radio-group>
					</v-col>
					<!-- date -->
					<v-col :cols="addVacation.timeType === timeTypeEnum.hourly ? 5 : 6">
						<bee-date-picker
							v-model="addVacation.date"
							:input-label="$T('inputs.date')"
							:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
							:months-over-max="100"
							menu-picker
							calendar
							no-title
							hide-details></bee-date-picker>
					</v-col>
					<!-- time -->
					<v-col
						cols="4"
						v-if="addVacation.timeType === timeTypeEnum.hourly">
						<v-text-field
							v-model="addVacation.time"
							type="time"
							outlined
							dense
							:label="$T('addVacation.time')"
							hide-details></v-text-field>
					</v-col>
					<!-- duration -->
					<v-col :cols="addVacation.timeType === timeTypeEnum.hourly ? 3 : 6">
						<v-text-field
							v-model="addVacation.duration"
							outlined
							dense
							:label="$T('addVacation.duration')"
							:suffix="addVacation.timeType === timeTypeEnum.hourly ? $T('addVacation.min') : null"
							:placeholder="
								addVacation.timeType === timeTypeEnum.hourly
									? $T('addVacation.minutes')
									: null
							"
							hide-details></v-text-field>
					</v-col>
					<!-- type -->
					<v-col cols="12">
						<b-async-input
							ref="types"
							:storeName="'leaveOrPermission/fetchLeaveBalanceById'"
							:payload="{id:employee?.employeeId }">
							<template v-slot:default="{ items, loading, focus }">
								<!-- {{loading}}
								{{ items }} -->
								<v-select
									v-model="addVacation.type"
									outlined
									dense
									:items="items"
									:loading="loading"
									:disabled="!employee"
									:item-text="(item) => `${ getLeavesById(item.leaveTypeId).name }`"
									item-value="leaveTypeId"
									menu-props="offset-y"
									:label="$T('addVacation.type')"
									hide-details
									@focus="focus">
									<template v-slot:no-data>
										<span>
											<v-progress-linear
												v-if="loading"
												indeterminate></v-progress-linear>
										</span>
									</template>
								</v-select>
							</template>
						</b-async-input>
					</v-col>
					<!-- cause -->
					<v-col cols="12">
						<v-text-field
							v-model="addVacation.cause"
							outlined
							dense
							:label="$T('addVacation.cause')"
							hide-details></v-text-field>
					</v-col>
				</v-row>
				<div
					class="text-body-1 mt-3"
					v-if="
						addVacation.date &&
						addVacation.duration &&
						(addVacation.timeType === timeTypeEnum.daily || addVacation.time)
					">
					تسجيل طلب إجازة
					<br />
					في تاريخ
					<strong> {{ moment(addVacation.date).format('L') }} </strong>
					<br />
					<template v-if="addVacation.timeType === timeTypeEnum.daily">
						وحتى تاريخ
						<strong>
							{{
								moment(addVacation.date).add(addVacation.duration, 'd').format('L')
							}}
						</strong>
					</template>
					<template v-if="addVacation.timeType === timeTypeEnum.hourly">
						من الساعة
						<strong>
							{{momentInstance(addVacation.time, 'hh:mm').format('hh:mm')}}
						</strong>
						وحتى الساعة
						<strong>
							{{
								momentInstance(addVacation.time, 'hh:mm')
									.add(addVacation.duration, 'm')
									.format('hh:mm')
							}}
						</strong>
					</template>
				</div>
			</v-card-text>
			<v-card-actions class="align-center">
				<v-spacer></v-spacer>
				<v-btn
					:loading="loadingAdding"
					:disabled="loadingAdding || cantAdd"
					color="secondary"
					@click="addVacationFun">
					{{ $T('default-buttons.save') }}
				</v-btn>
			</v-card-actions>
		</v-form>
	</v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment, { momentInstance } from '@/utils/moment';
import { nextTick } from 'vue';
import { timeTypeEnum } from '@/utils/enum';

export default {
	name: 'AddVacationComponent',

	props: {
		oneEmployee: { type: String },
		vacationType: { type: Number },
		selectedItem: { type: Object },
	},

	data() {
		return {
			loadingAdding: false,

			employee: null,

			addVacation: {
				id: null,
				type: null,
				timeType: timeTypeEnum.daily,
				date: new Date().toISOString().slice(0, 10),
				time: null,
				cause: null,
				duration: null,
			},

			timeTypeEnum,
		};
	},

	watch: {
		'addVacation.timeType'() {
			this.addVacation.time = null;
			this.addVacation.type = null;
		},
		oneEmployee() {
			this.handelEmployee();
		},
		selectedItem() {
			this.handelData();
		},
	},

	computed: {
		cantAdd() {
			const check =
				!this.employee ||
				!this.addVacation.type ||
				!this.addVacation.date ||
				!this.addVacation.duration;

			if (this.addVacation.timeType === timeTypeEnum.daily) {
				return check;
			} else {
				return check || !this.addVacation.time;
			}
		},
		...mapState({
			employees: (state) => state.employee.employees,
			leaves: state => state.leaveOrPermission.leaves
		}),
		...mapGetters({
			getLeavesById: 'leaveOrPermission/getLeavesById'
		})
	},

	methods: {
		addVacationFun() {
			if (this.cantAdd) return;
			this.loadingAdding = true;

			this.$store
				.dispatch('attendance/addVacation', {
					id: this.addVacation.id,
					employeeId: this.employee.employeeId,
					vacation: this.addVacation,
					type: this.vacationType,
				})
				.then(() => {
					this.$emit('close');
					this.$emit('done');
					this.clear();
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), {
						done: true,
					});
				})
				.catch((err) => {
					err.default && err.default(this.$T('messages.add-fail'), false);
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},

		handelEmployee() {
			this.employee = null;
			if (this.oneEmployee)
				this.employee = this.employees.find((e) => e.employeeId === this.oneEmployee);
		},
		handelData() {
			this.clear();
			if (this.selectedItem) {
				this.loadingAdding = true;
				this.$store.dispatch('filters/fetchVacationsTypes').then((res) => {
					this.$refs.types.addItems(res);

					// info: this used for time input
					this.addVacation.timeType = this.selectedItem.isDaily
						? timeTypeEnum.daily
						: timeTypeEnum.hourly;

					nextTick(() => {
						this.addVacation = {
							id: this.selectedItem.id,
							type: this.selectedItem.leaveTypeId,
							timeType: this.selectedItem.isDaily ? timeTypeEnum.daily : timeTypeEnum.hourly,
							date: moment(this.selectedItem.date).format('L'),
							time: moment(this.selectedItem.startTime).format('HH:mm'),
							cause: this.selectedItem.reason,
							duration: this.selectedItem.durationInDay || this.selectedItem.durationInMinute,
						};
					});
					this.loadingAdding = false;
				});
			}
		},
		clear() {
			this.addVacation = {
				type: null,
				timeType: null,
				date: new Date().toISOString().slice(0, 10),
				time: null,
				cause: null,
				duration: null,
			};
		},
		moment,
		momentInstance,
	},

	mounted() {
		this.handelEmployee();
		this.handelData();
	},
};
</script>
